import ApplicationSerializer from 'eflex/serializers/application';

export default class BuildStatusChildSerializer extends ApplicationSerializer {
  attrs = {
    liveBuildStatus: {
      serialize: false,
      deserialize: false,
    },
    buildStatus: {
      serialize: false,
      deserialize: false,
    },
    decisionProcessData: {
      embedded: 'always',
    },
    processData: {
      embedded: 'always',
    },
    boltProcessData: {
      embedded: 'always',
    },
    errorProofingProcessData: {
      embedded: 'always',
    },
    visionProcessData: {
      embedded: 'always',
    },
    scheduleProcessData: {
      embedded: 'always',
    },
    edhrProcessData: {
      embedded: 'always',
    },
    uploadedData: {
      embedded: 'always',
    },
  };
}
